module.exports = __webpack_public_path__ + "cb366ae5dadb1593325d3aa2a9421caa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/microsoft_2023_chart.png
// module id = 1694
// module chunks = 0